import { render, staticRenderFns } from "./empty_state_without_any_issues.vue?vue&type=template&id=7aa2c6f6&scoped=true"
import script from "./empty_state_without_any_issues.vue?vue&type=script&lang=js"
export * from "./empty_state_without_any_issues.vue?vue&type=script&lang=js"
import style0 from "./empty_state_without_any_issues.vue?vue&type=style&index=0&id=7aa2c6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa2c6f6",
  null
  
)

export default component.exports